<template>
  <b-row class="m-0 chartTabPanel autoCursor">
    <b-col ref="capture">
      <Plotly
        v-if="loaded"
        :layout="layout"
        :data="chartData"
        :display-mode-bar="false"
        :xAxisType="xAxisType"
        :yAxisType="yAxisType"
        :margin="margin"
        :title="chartTitle"
        :name="name"
        :width="setChartWidth"
        :heigt="chartHeight"
        :chartBarMode="chartBarMode"
        :tickFormat="tickFormat"
        :tickFormatX="tickFormatX"
        :tickFormatYaxis2="tickFormatYaxis2"
        :yAxisTitle="yAxisTitle"
        :ynticks="ynticks"
        :rangeslider="rangeslider"
        :min="minValue"
        :max="maxValue"
      /> </b-col
  ></b-row>
</template>

<script>
import { Plotly } from "vue-plotly";

import { mapActions, mapGetters } from "vuex";
export default {
  name: "PlotlyMultiLineChart",
  props: {
    dataSet: {
      default: [],
    },
    xField: {
      default: "xField",
    },
    yField: {
      default: "yField",
    },
    name: {
      default: "",
    },
    margin: {
      default: {
        l: 80,
        r: 80,
        b: 0,
        t: 0,
        pad: 2,
      },
    },
    title: {
      default: "",
    },
    yAxisType: {
      default: "linear",
    },
    xAxisType: {
      default: "ordinal",
    },
    sliderHide: {
      default: false,
    },

    yearOption: {
      type: [String, Array],
      default: function() {
        return [];
      },
    },
    yearDrop: {
      default: false,
    },
    chartWidth: { default: "100%" },
    chartHeight: { default: "100%" },
    tickFormat: { default: "" },
    tickFormatX: { default: "" },
    tickFormatYaxis2: { default: "" },
    yAxisTitle: { default: "" },
    ynticks: { default: 4 },
    rangeslider: { default: false },
    chartTitle: { default: "" },
    chartBarMode: { default: "" },
    min: { default: 2018 },
    max: { default: 2018 },
  },

  components: {
    Plotly,
  },
  data() {
    return {
      loaded: true,
      layout: {},
      chartData: [],
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      fullscreen: false,
      sliderValue: { default: [2018, 2024] },
      // max:'2024',
      setChartWidth: this.chartWidth,
      minValue: this.min ? this.min : 2000,
      maxValue: this.max ? this.max : 2022,
    };
  },
  created() {
    window.addEventListener("resize", this.windowResize);
    this.sliderValue = [this.minValue, this.maxValue];
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },
  mounted() {
    this.createChart();
  },
  computed: {
    //...mapGetters({isFullScreen:"isFullScreen"}),
  },
  methods: {
    ...mapActions(["setDownloadInfo"]),
    windowResize(e) {
      this.layout.width = this.$refs.capture.clientWidth - 50;
    },
    unpack(rows, key) {
      return rows.map(function(row) {
        return row[key];
      });
    },
    createChart() {
      //this.setDownloadInfo({'fileName':this.title,"downloadData":this.$refs.capture});
      this.chartData = this.dataSet;
      if (this.chartData && this.chartData.length) {
        for (let i = 0; i < this.chartData.length; i++) {
          if (Object.keys(this.chartData[i]).includes("year")) {
            this.maxValue = Math.max.apply(Math, this.chartData[i].year);
            this.minValue = Math.min.apply(Math, this.chartData[i].year);
            this.sliderValue = [this.minValue, this.maxValue];
            break;
          }
        }
      }
      // console.log('this.chartBarMode-===',this.chartData,this.dataSet);
      //-------------Chart Layout-------------
      this.setChartWidth = this.$refs.capture.clientWidth - 50;
      this.layout = {
        title: this.title,
        margin: this.margin,
        minWidth: this.setChartWidth,
        height: this.chartHeight,
        barmode: this.chartBarMode,
        xaxis: {
          autorange: true,
          nticks: 12,
          rangeslider: {
            range: [],
            visible: this.rangeslider,
          },

          showgrid: false,
          showline: true,
          zeroline: true,
          linecolor: "#636363",
          anchor: "y",
          ticklen: 5,
        },
        yaxis: {
          autorange: true,
          nticks: this.ynticks,
          type: "linear",
          showgrid: false,
          showline: true,
          linecolor: "#636363",
          anchor: "x",
          zeroline: false,
          ticklen: 5,
          tickformat: this.tickFormat,
          title: {
            text: this.yAxisTitle,
            standoff: 40,
          },
        },
        yaxis2: {
          autorange: true,
          type: "linear",
          showgrid: false,
          showline: true,
          linecolor: "#636363",
          anchor: "x",
          zeroline: false,
          ticklen: 5,
          overlaying: "y",
          side: "right",
          tickformat: this.tickFormatYaxis2,
        },
        showLegend: true,
        legend: {
          x: 0.35,
          y: this.rangeslider ? -0.8 : -0.3,
          orientation: "h",
        },
        traceorder: "normal",
        font: {
          family: "sans-serif",
          size: 12,
          color: "#000",
        },
        bgcolor: "#2E2EE2",
        bordercolor: "silver",
        borderwidth: 2,
      };
    },
    slideChange(e) {
      var chartData = JSON.parse(sessionStorage.getItem("totalcalls"));
      for (let y = 0; y < chartData.length; y++) {
        let filterData = {
          x: [],
          y: [],
          mode: chartData[0].mode,
          name: chartData[y].name,
        };
        for (let i = 0; i < chartData[0].x.length; i++) {
          if (
            chartData[y] &&
            chartData[y].x &&
            chartData[y].x[i] &&
            parseInt(chartData[y].x[i].split("-")[1]) >=
              parseInt(e[0].toString().substr(-2)) &&
            parseInt(chartData[y].x[i].split("-")[1]) <=
              parseInt(e[1].toString().substr(-2))
          ) {
            filterData.x.push(chartData[y].x[i]);
            filterData.y.push(chartData[y].y[i]);
          }
          this.totalCalls[y].x = filterData.x;
          this.totalCalls[y].y = filterData.y;
        }
      }
      this.totalCalls.upperRange = e[1];
      this.totalCalls.lowerRange = e[0];
    },
    yearChange() {
      //test
    },
  },
};
</script>
